import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { journeyRoute, trackGuideAction, captureGuideClick } from "@/lib/guideJourney";
import TopNav from "@/components/yts/TopNav";
import SiteFooter from "@/components/yts/SiteFooter";

export default function AppLayout() {
  const loc = useLocation();
  useEffect(() => {
    const section = journeyRoute(loc.pathname);
    if (section) trackGuideAction("guide_section_view", { section });
  }, [loc.pathname]);
  // The map fills exactly the space between the sticky header and the bottom
  // nav, so that page never scrolls; every other page flows normally with room
  // for the nav at the end of the document.
  const isMap = loc.pathname === "/map";
  const isStore = loc.pathname.startsWith("/perfumeria-pr");
  const isPrivate = loc.pathname.startsWith("/after-dark");
  // The footer closes every page but the map, and it carries the room the
  // bottom nav needs on mobile.
  const pad = isMap ? "pb-[calc(68px_+_env(safe-area-inset-bottom,0px))] sm:pb-0" : "";

  return (
    <div className={`yts-site ${isStore ? "yts-storefront" : "yts-editorial"} min-h-[100dvh] flex flex-col bg-white text-[#111111]`}>
      {!isStore && <TopNav />}
      <main onClickCapture={captureGuideClick} className={`flex-1 min-h-0 flex flex-col ${pad}`}> 
        <Outlet />
      </main>
      {!isMap && !isStore && !isPrivate && <SiteFooter />}
    </div>
  );
}